<template>
  <b-modal
    ref="modal"
    :title="isEditMode ? $t('editMaterial') : $t('createMaterial')"
    centered
    size="lg"
    :hide-footer="true"
    @hidden="resetForm"
  >
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent="handleSubmit">
        <div class="row mb-2">
          <div class="col-12 col-md-4">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Material Name"
                rules="required"
              >
                <label class="form-label input-label">
                  {{ $t('materialName') }} <span style="color: #f00">*</span>
                </label>
                <b-form-input
                  v-model="form.name"
                  :placeholder="$t('materialName')"
                  :class="{ 'is-invalid': errors[0] }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="col-12 col-md-4">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Material Name (German)"
                rules="required"
              >
                <label class="form-label input-label">
                  {{ $t('materialName') }} (DE) <span style="color: #f00">*</span>
                </label>
                <b-form-input
                  v-model="form.name_de"
                  :placeholder="$t('materialName') + ' (DE)'"
                  :class="{ 'is-invalid': errors[0] }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="col-12 col-md-4">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Material Name (French)"
                rules="required"
              >
                <label class="form-label input-label">
                  {{ $t('materialName') }} (FR) <span style="color: #f00">*</span>
                </label>
                <b-form-input
                  v-model="form.name_fr"
                  :placeholder="$t('materialName') + ' (FR)'"
                  :class="{ 'is-invalid': errors[0] }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="col-12 col-md-4">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Material Name (Spanish)"
                rules="required"
              >
                <label class="form-label input-label">
                  {{ $t('materialName') }} (ES) <span style="color: #f00">*</span>
                </label>
                <b-form-input
                  v-model="form.name_es"
                  :placeholder="$t('materialName') + ' (ES)'"
                  :class="{ 'is-invalid': errors[0] }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="col-12 col-md-4">
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Material Name (Turkish)"
                rules="required"
              >
                <label class="form-label input-label">
                  {{ $t('materialName') }} (TU) <span style="color: #f00">*</span>
                </label>
                <b-form-input
                  v-model="form.name_tu"
                  :placeholder="$t('materialName') + ' (TU)'"
                  :class="{ 'is-invalid': errors[0] }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="col-12 col-md-4">
            <div class="checkbox-group d-inline-block mt-2">
              <input
                id="isDefault"
                class="checkbox-input"
                v-model="form.is_default_shown"
                type="checkbox"
                name="isDefault"
              />
              <label class="checkbox-label" for="isDefault">{{
                $t("isDefault")
              }}</label>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="checkbox-group d-inline-block">
              <input
                id="isNotDeleteable"
                class="checkbox-input"
                v-model="form.is_default"
                type="checkbox"
                name="isNotDeleteable"
              />
              <label class="checkbox-label" for="isNotDeleteable">{{
                $t("isNotDeleteable")
              }}</label>
            </div>
          </div>
        </div>
        <div class="mb-1">
          <label class="form-label input-label mb-1">
            {{ $t('parameters') }}
          </label>
          <div
            v-for="(parameter, index) in form.parameters"
            :key="parameter.id || index"
            class="border rounded p-1"
          >
            <div class="d-flex justify-content-between align-items-center mb-1">
              <h4 class="mb-0">{{ $t(parameter.name) }}</h4>
            </div>
            <div class="row">
              <div class="col-12 col-md-4">
                <b-form-group>
                  <label class="form-label input-label">
                    {{ $t('minValue') }}
                  </label>
                  <b-form-input
                    v-model.number="parameter.minValue"
                    type="number"
                    step="0.001"
                  />
                </b-form-group>
              </div>
              <div class="col-12 col-md-4">
                <b-form-group>
                  <label class="form-label input-label">
                    {{ $t('maxValue') }}
                  </label>
                  <b-form-input
                    v-model.number="parameter.maxValue"
                    type="number"
                    step="0.001"
                  />
                </b-form-group>
              </div>
              <div class="col-12 col-md-4">
                <b-form-group>
                  <label class="form-label input-label">
                    {{ $t('defaultValue') }}
                  </label>
                  <b-form-input
                    v-model.number="parameter.defaultValue"
                    type="number"
                    step="0.001"
                  />
                </b-form-group>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-end mt-2">
          <b-button
            variant="secondary"
            @click="$refs.modal.hide()"
            class="mr-2"
          >
            {{ $t('cancel') }}
          </b-button>
          <b-button
            type="submit"
            variant="primary"
            :disabled="isSubmitting"
          >
            {{ isEditMode ? $t('update') : $t('create') }}
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    material: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isSubmitting: false,
      form: {
        name: "",
        name_de: "",
        name_fr: "",
        name_es: "",
        name_tu: "",
        is_default_shown: false,
        is_default: false,
        parameters: [],
      },
    };
  },
  computed: {
    isEditMode() {
      return !!this.material;
    },
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.$refs.modal.show();
        if (this.material) {
          this.loadMaterialData();
        } else {
          this.initializeDefaultParameters();
        }
      } else {
        this.$refs.modal.hide();
      }
    },
    material: {
      handler() {
        if (this.material && this.show) {
          this.loadMaterialData();
        }
      },
      deep: true,
    },
  },
  methods: {
    initializeDefaultParameters() {
      this.form = {
        name: "",
        name_de: "",
        name_fr: "",
        name_es: "",
        name_tu: "",
        is_default_shown: false,
        is_default: false,
        parameters: [
          {
            name: "Cement Gap",
            defaultValue: 0.05,
            minValue: 0,
            maxValue: 0.5,
          },
          {
            name: "Cement Gap Start",
            defaultValue: 1.00,
            minValue: 0.00,
            maxValue: 5.00,
          },
          {
            name: "Border Thickness",
            defaultValue: 0.30,
            minValue: 0.00,
            maxValue: 1.00,
          },
          {
            name: "Minimum Thickness",
            defaultValue: 0.50,
            minValue: 0.00,
            maxValue: 2.00,
          },
          {
            name: "Milling head diameter",
            defaultValue: 1.10,
            minValue: 0.00,
            maxValue: 3.00,
          },
          {
            name: "Occlusal Contact Strength",
            defaultValue: 0.000,
            minValue: -1.000,
            maxValue: 1.000,
          },
          {
            name: "Proximal Contact Strength",
            defaultValue: 0.000,
            minValue: -1.000,
            maxValue: 1.000,
          },
          {
            name: "Gingival Contact Strength",
            defaultValue: 0.000,
            minValue: 0.000,
            maxValue: 1.000,
          },
        ],
      };
    },
    loadMaterialData() {
      if (this.material) {
        this.form = {
          name: this.material.name || "",
          name_de: this.material.name_de || "",
          name_fr: this.material.name_fr || "",
          name_es: this.material.name_es || "",
          name_tu: this.material.name_tu || "",
          is_default_shown: this.material.is_default_shown || false,
          is_default: this.material.is_default || false,
          parameters: this.material.parameters.map((param) => ({
            id: param.id,
            name: param.name,
            defaultValue: param.defaultValue,
            minValue: param.minValue,
            maxValue: param.maxValue,
          })),
        };
      }
    },
    async handleSubmit() {
      const isValid = await this.$refs.simpleRules.validate();
      if (!isValid) return;

      this.isSubmitting = true;
      this.$store.commit("showLoader", true);
      try {
        const payload = {
          name: this.form.name,
          name_de: this.form.name_de,
          name_fr: this.form.name_fr,
          name_es: this.form.name_es,
          name_tu: this.form.name_tu,
          is_default_shown: this.form.is_default_shown,
          is_default: this.form.is_default,
          parameters: this.form.parameters.map((param) => ({
            id: param.id,
            name: param.name,
            defaultValue: param.defaultValue,
            minValue: param.minValue,
            maxValue: param.maxValue,
          })),
        };

        if (this.isEditMode) {
          await this.$store.dispatch("materialsConfiguration/update", {
            materialId: this.material.id,
            data: payload,
          });
        } else {
          await this.$store.dispatch("materialsConfiguration/store", payload);
        }

        this.$emit("saved");
        this.$refs.modal.hide();
      } catch (e) {
        console.error("Error saving material:", e);
      } finally {
        this.isSubmitting = false;
        this.$store.commit("showLoader", false);
      }
    },
    resetForm() {
      this.form = {
        name: "",
        name_de: "",
        name_fr: "",
        name_es: "",
        name_tu: "",
        is_default_shown: false,
        is_default: false,
        parameters: [],
      };
      this.$emit("close");
    },
  },
};
</script>

